
import React, { useState } from 'react';
import {Home, Phone} from "lucide-react";
import {Link} from 'react-router-dom';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <header className="sticky top-0 z-50 w-full bg-[#1a1d24] text-white shadow-md">
            {/* Navigation */}
            <nav className="bg-white/80 backdrop-blur-md fixed w-full z-50 border-b border-slate-100 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">

                    <button
                        className="flex flex-col gap-1.5 md:hidden"
                        onClick={() => setIsMenuOpen((prev) => !prev)}
                        aria-label="Toggle navigation"
                    >
                        <span className="h-0.5 w-6 rounded bg-emerald-600"></span>
                        <span className="h-0.5 w-6 rounded bg-emerald-600"></span>
                        <span className="h-0.5 w-6 rounded bg-emerald-600"></span>
                    </button>

                    <div className="flex items-center gap-2 font-bold text-xl text-slate-900 md:block hidden">
                        <a href="/">
                            {/*<Home className="text-emerald-600" />*/}
                            <span className={'flex'}><Home className="text-emerald-600 mx-2" /> Hlushman House</span>
                        </a>
                    </div>

                    <div className={`${
                        isMenuOpen ? 'flex text-white' : 'hidden'
                    } md:flex gap-8 text-sm font-medium text-slate-600 absolute left-0 top-full w-full flex-col items-center gap-5 bg-emerald-600 py-6 md:static md:flex md:w-auto md:flex-row md:bg-transparent md:py-0`}>

                        {isMenuOpen  && (<a href="/" className="hover:text-emerald-600 transition" onClick={() => setIsMenuOpen(false)}>Головна</a>)}

                        <Link to={'/sell-house'} className="hover:text-emerald-600 transition"  onClick={() => setIsMenuOpen(false)}>Продаж Будинку</Link>
                        <Link to={'/rent-house'} className="hover:text-emerald-600 transition"  onClick={() => setIsMenuOpen(false)}>Оренда Будинка</Link>
                        <Link to={'#products'} className="hover:text-emerald-600 transition"  onClick={() => setIsMenuOpen(false)}>Дерев'яні вироби</Link>
                        {
                            isMenuOpen  && (
                                <>
                                    <Link to={'/about'} className="hover:text-emerald-600 transition"  onClick={() => setIsMenuOpen(false)}>Про нас</Link>
                                    <Link to={'/contacts'} className="hover:text-emerald-600 transition"  onClick={() => setIsMenuOpen(false)} >Контакти</Link>
                                </>
                            )
                        }
                    </div>
                    <Link
                        to={'tel:+380686137593'}
                        className="bg-emerald-600 text-white px-4 py-2 rounded-xl text-sm font-semibold hover:bg-emerald-700 transition flex items-center gap-2"
                    >
                        <Phone size={16} />
                        <span>Зателефонувати</span>
                    </Link>
                </div>
            </nav>

        </header>
    );
};

export default Header;